export default __webpack_public_path__ + "static/media/FAITH Customer Success Manager.366c3328.png";